import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = currentDate.getMonth(); // 0-based index, so January is 0

// Indian financial year starts in April
const fiscalYearStart = currentMonth >= 3 ? currentYear : currentYear - 1;
const fiscalYearEnd = fiscalYearStart + 1;

const fiscalYearLabel = `FY ${fiscalYearStart}-${fiscalYearEnd}`;
const fiscalYearValue = String(fiscalYearStart).slice(-2);

let FYear = {
  label: fiscalYearLabel,
  value: fiscalYearValue,
};

axios.defaults.headers["fy_id"] = FYear?.value;

const initialState = {
  FYear,
  FinancialYearArray: [FYear],
};

const FinancialYearSlice = createSlice({
  name: "FinancialYear",
  initialState,
  reducers: {
    setFinancialYearArray(state, action) {
      state.FinancialYearArray = action.payload;
    },
    editFinancialYear(state, action) {
      state.FYear = action.payload;
      axios.defaults.headers["fy_id"] = action.payload?.value;
    },
  },
});
export const { editFinancialYear, setFinancialYearArray } =
  FinancialYearSlice.actions;
export default FinancialYearSlice.reducer;
